module.exports = __webpack_public_path__ + "static/media/fax.19fb3541.png";